/* 📁 ASSETS*/
import { Arrow } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, OutButton, NameContainer, ValuesContainer, ArrowContainer, ArrowIMG, NameText, OldValueText, NewValueText, StateContainer, ModeContainer } from "./styles";

const ConfirmComand = ({ name, type, oldValue, newValue, background, Function }) => {
    return(
        <Container $background={background%2 === 0}>
            <OutButton onClick={()=>{
                return Function();
            }}>
                &#x2716;
            </OutButton>
            <NameContainer>
                <NameText>
                    {name}
                </NameText>
            </NameContainer>

            <ValuesContainer>
                {type === 'state' ?
                    <StateContainer $state={oldValue === 1}>{oldValue === 1 ? 'L' : 'D'}</StateContainer>
                    :
                    type === 'modo' ?
                    <ModeContainer>{oldValue === 0 ? 'M' : oldValue === 1 ? 'S' : oldValue === 2 ? 'A' : ''}</ModeContainer>
                    :
                    <OldValueText>
                        {oldValue}
                    </OldValueText>
                }
            </ValuesContainer>

            <ArrowContainer>
                <ArrowIMG src={Arrow}/>
            </ArrowContainer>

            <ValuesContainer>
                {type === 'state' ?
                    <StateContainer $state={newValue === 1}>{newValue === 1 ? 'L' : 'D'}</StateContainer>
                    :
                    type === 'modo' ?
                    <ModeContainer>{newValue === 0 ? 'M' : newValue === 1 ? 'A' : newValue === 2 ? 'S' : ''}</ModeContainer>
                    :
                    <NewValueText>
                        {newValue}
                    </NewValueText>
                }
            </ValuesContainer>
        </Container>
    )
}

export default ConfirmComand;